import {BaseObject} from './BaseObject';

export class AresMetadata {
    pravniForma: string;
    textovaAdresa: string;
    datumVzniku: string;
    datumAktualizace: string;
}

export class AresResponse extends BaseObject {
    invoiceCompanyNumber: string;
    invoiceVatNumber: string;
    name: string;
    invoiceName: string;
    alternativeName: string;
    invoiceStreet: string;
    invoiceCity: string;
    invoiceZip: string;
    contactStreet: string;
    contactCity: string;
    contactZip: string;
    invoiceVatPayer: boolean;
    _ares: AresMetadata;
}



// WEBPACK FOOTER //
// /app/src/model/Entities/AresResponse.ts